export default __webpack_public_path__ + "static/media/3_2.f4242458.jpg";